import { useAppSelector } from '../../../lib/store';
import { selectActiveStep } from '../state/selector';
import { BasicsStep } from './steps/BasicsStep';
import { ConceptGroupsAndAttributesStep } from './steps/ConceptGroupsAndAttributes';
import { DatasetImport } from './steps/DatasetImport';
import { DataSplitting } from './steps/DataSplitting';
import { PeopleAllocation } from './steps/PeopleAllocation';
import { ReviewAndCreate } from './steps/ReviewAndCreate';

interface StepRendererProps {
  setRequiredFieldsFilled: (fieldsFilled: boolean) => void;
}
export const StepRenderer = ({ setRequiredFieldsFilled }: StepRendererProps) => {
  const activeStep = useAppSelector(selectActiveStep);
  switch (activeStep) {
    case 0:
      return <BasicsStep setRequiredFieldsFilled={setRequiredFieldsFilled} />;
    case 1:
      return <ConceptGroupsAndAttributesStep setRequiredFieldsFilled={setRequiredFieldsFilled} />;
    case 2:
      return <DatasetImport setRequiredFieldsFilled={setRequiredFieldsFilled} />;
    case 3:
      return <DataSplitting setRequiredFieldsFilled={setRequiredFieldsFilled} />;
    case 4:
      return <PeopleAllocation setRequiredFieldsFilled={setRequiredFieldsFilled} />;
    case 5:
      return <ReviewAndCreate setRequiredFieldsFilled={setRequiredFieldsFilled} />;
    default:
      return null;
  }
};
